// test582
(582 && 0);
